import { removeDupes } from '../utils/helpers';

const subteams = (state = {
    items: [],
    fetched: false,
    error: false,
    loading: true,
    shouldRefetch: false
}, action) => {
    if (action.error) {
        return state;
    }

    switch (action.type) {
        case 'TEAM_CHANGE':
        case 'RESET_STORE':
            return {
                items: [],
                fetched: false,
                error: false,
                loading: true
            };

        case 'MARK_ALL_FOR_REFETCH':
            return Object.assign({}, state, {
                shouldRefetch: true
            });

        case 'SUBTEAMS_FETCH_REQUESTED':
            if (action.payload && action.payload.archived) {
                return state;
            }

            return Object.assign({}, state, {
                error: false,
                loading: true,
                shouldRefetch: false
            });

        case 'SUBTEAMS_FETCH_FAILED':
            if (action.payload.archived) {
                return state;
            }

            return Object.assign({}, state, {
                loading: false,
                fetched: true,
                error: action.payload.message || true
            });

        case 'SUBTEAMS_FETCH_SUCCEEDED':
            if (!action.payload || !action.payload.subteams) {
                return state;
            }

            if (action.payload.archived) {
                return Object.assign({}, state, {
                    items: removeDupes([...state.items, ...action.payload.subteams])
                });
            }

            return Object.assign({}, state, {
                items: removeDupes([...state.items, ...action.payload.subteams]),
                loading: false,
                fetched: true,
                error: false
            });

        case 'SUBTEAM_CREATE_REQUESTED':
        case 'SUBTEAM_ADD_SOCKET':
            return Object.assign({}, state, {
                items: removeDupes([action.payload.subteam, ...state.items])
            });

        case 'SUBTEAM_CREATE_FAILED':
            return Object.assign({}, state, {
                items: state.items.filter(subteam => subteam !== action.payload.fragment)
            });

        case 'SUBTEAM_CREATE_SUCCEEDED':
            return Object.assign({}, state, {
                items: state.items
                    .filter(subteam => subteam.id !== action.payload.subteamId)
                    .map(subteam => {
                        if (subteam === action.payload.fragment) {
                            return Object.assign({}, subteam, action.payload.subteam);
                        }

                        return subteam;
                    })
            });

        case 'SUBTEAM_FETCH_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.filter(subteam => subteam.id !== action.payload.subteamId), {
                    id: action.payload.subteamId,
                    loading: true
                }]
            });

        case 'SUBTEAM_FETCH_FAILED':
            return Object.assign({}, state, {
                items: [...state.items.filter(subteam => subteam.id !== action.payload.subteamId), {
                    id: action.payload.subteamId,
                    error: true
                }]
            });

        case 'SUBTEAM_FETCH_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.filter(subteam => subteam.id !== action.payload.subteam.id), action.payload.subteam]
            });

        case 'SUBTEAM_UPDATE_REQUESTED':
        case 'SUBTEAM_UPDATE_SOCKET':
            if (!state.items.some(subteam => subteam.id === action.payload.subteamId)) {
                return Object.assign({}, state, {
                    items: [...state.items, action.payload.subteam]
                });
            }

            return Object.assign({}, state, {
                items: [...state.items].map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, (action.payload.subteam || action.payload.subteamProps));
                    }

                    return subteam;
                })
            });

        case 'SUBTEAM_REMOVE_REQUESTED':
        case 'SUBTEAM_REMOVE_SOCKET':
            return Object.assign({}, state, {
                items: state.items.filter(subteam => subteam.id !== action.payload.subteamId)
            });

        case 'SUBTEAM_LEAVE_REQUESTED':
        case 'SUBTEAM_KICK_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items.map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, {
                            members: (subteam.members || []).filter(userId => !action.payload.userId)
                        });
                    }

                    return subteam;
                })]
            });

        case 'SUBTEAM_TRANSFER_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items.map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, {
                            owner: action.payload.userId
                        });
                    }

                    return subteam;
                })]
            });

        case 'SUBTEAM_ADD_MEMBERS_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, {
                            members: [...new Set([...(subteam.members || []), ...action.payload.users])]
                        });
                    }

                    return subteam;
                })]
            });

        case 'SUBTEAM_REMOVE_MEMBERS_SUCCEEDED':
            return Object.assign({}, state, {
                items: [...state.items.map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, {
                            members: (subteam.members || []).filter(userId => !action.payload.users.includes(userId))
                        });
                    }

                    return subteam;
                })]
            });

        case 'SUBTEAM_USER_REMOVE_SOCKET':
        case 'SUBTEAM_REMOVE_USER_REQUESTED':
            return Object.assign({}, state, {
                items: [...state.items].map(subteam => {
                    if (subteam.id === action.payload.subteamId) {
                        return Object.assign({}, subteam, {
                            members: (subteam.members || []).filter(userId => userId !== action.payload.userId)
                        });
                    }

                    return subteam;
                })
            });

        case 'USER_REMOVE_REQUESTED':
        case 'TEAM_USER_REMOVE_SOCKET':
        case 'USER_INVITE_CANCEL_SOCKET':
            return Object.assign({}, state, {
                items: [...state.items].map(subteam => {
                    if ((!action.payload.subteamId || action.payload.subteamId === subteam.id) && !action.payload.projectId && !action.payload.projectsOnly) {
                        return Object.assign({}, subteam, {
                            members: (subteam.members || []).filter(userId => userId !== action.payload.userId)
                        });
                    }

                    return subteam;
                })
            });

        default:
            return state;
    }
}

export default subteams;
